import { useIntl } from 'react-intl';
import { type IPageItem, type Translation } from '../../../../common/interfaces';
import { ImageLink, Img } from './Image.styled';

export const Image = (props: { item: IPageItem; translations: Translation[] | undefined }) => {
  const { item, translations } = props;
  const { settings } = item;
  const intl = useIntl();

  const getAltText = (): string => {
    return settings?.imageAltText || '';
  };

  const getUrl = (): string | null => {
    const config = settings?.buttonConfig;
    if (config?.display !== 'none') {
      let url = '';
      let categoryId = '';

      switch (config?.display) {
        case 'submitIdea':
          categoryId = config?.category.replace(/[^0-9]+/g, '');
          url = '/category';
          break;
        case 'challenges':
          url = '/category/browse';
          break;
        case 'custom':
          url = config?.externalUrl;
          break;
        default:
          url = config?.url;
      }
      return categoryId ? `${url}/${categoryId}` : url;
    }
    return null;
  };

  const handleToolTip = (displayType: string): string => {
    const toolTipMap = {
      submitIdea: intl.formatMessage({ id: 'page.postAnIdea', defaultMessage: 'Post an idea' }),
      challenges: intl.formatMessage({ id: 'page.viewChallenges', defaultMessage: 'View Challenges' }),
      custom: translations?.[0]?.value || settings?.buttonConfig?.text,
      default: settings?.buttonConfig?.text
    };

    return toolTipMap[displayType as keyof typeof toolTipMap] || toolTipMap.default;
  };

  const url = getUrl();
  const altText = getAltText();

  const imgElement = (
    <Img
      alt={altText}
      src={settings?.imageUrl}
      title={handleToolTip(settings?.buttonConfig?.display)}
      $settings={settings}
    />
  );

  return (
    <div data-testid="imageComponent">
      {url ? (
        <ImageLink href={url} data-testid="image-link">
          {imgElement}
        </ImageLink>
      ) : (
        imgElement
      )}
    </div>
  );
};
